import React, { useState, useEffect } from 'react';
import { Dialog, Card } from '@mui/material';
import { images, icons } from "../../helpers/constants";
import { useTranslation } from "react-i18next";
import Button from '../Buttons/Button';
import { useIsMobile } from '../../helpers/customHooks';
import { useContextData } from '../ContextData';
import * as request from "../../services/FetchService";
import { staticSort } from '../../helpers/helperFunctions';
import toast from 'react-hot-toast';

const NewSupportTicketModal = (props) => {
    const MOBILE = useIsMobile();
    const [show, setShow] = useState(props.show)
    const { t } = useTranslation();
    const { deviceListCompact } = useContextData();
    const [deviceList, setDeviceList] = useState()
    const [selectedDevice, setSelectedDevice] = useState(-1)
    const [message, setMessage] = useState("")
    const [messageSent, setMessageSent] = useState(false)

    const handleClose = () => {
        props.onClose()
      //  setShow(false)
    }
    useEffect(() => {
        setShow(props.show)
    },[props.show])
    const getIssues = () => {
        request.post("", "services/support/getissues", {language: localStorage.getItem("language") ? localStorage.getItem("language") : "en"}).then((response) => {
            //setIssueList(response.data.issues);
            let sorted = staticSort(response.data.devices, "devicename")
            setDeviceList(sorted);
            //setValid(response.data.valid)
        }); 
    }

    useEffect(() => {
       // getDevices()
        getIssues()
    }, [])

    const sendMessage = async () => {
        if(!selectedDevice || selectedDevice === -1){
            toast.error(t("toast.no_device_selected"))
            return
        }
        if(!message || message === ""){
            toast.error(t("toast.no_message"))
            return
        }
        let data = {
            deviceid: parseInt(selectedDevice),
            message
        }

        console.log("DATA?: ", data)
        request.post("", "account/support/tickets/create", data).then((response) => {
            if(response.data.successful){
                toast.success(t("toast.sent"))
                props.onClose()
                setMessageSent(true)
            }
		}); 
    }
    
    
    return(
        <>
        <Dialog fullWidth={MOBILE ? true : false} open={show} onClose={handleClose}>
            <Card className="settings-dialog d-flex flex-column">
                <div className="w-100 h-100">
                    <div className="d-flex flex-row p-3 justify-content-between border-settings align-items-center">
                        <div className='d-flex align-items-center'>
                            <img src={icons.questionmark} alt=""/>
                            <h3 className="ms-2">{t("settings.new_ticket")}</h3>
                        </div>
                        <img className="cursor-pointer" src={icons.close_gray} onClick={() => props.onClose()} alt="..." /> 
                    </div>
                    <div className="p-3">
                        <p className="thin dark-grey text-center pb-3">{t("settings.new_ticket_desc")}</p>
                        <div className="d-flex flex-column flex-fill w-100 mb-3">
                            <p className="bold">{t("settings.device")}</p>
                            <select
                                onChange={(event) => setSelectedDevice(event.target.value)}
                                value={selectedDevice}
                                className="form-control bg-light-grey"
                            >
                                <option value="">{t("settings.select")}</option>
                                {deviceList && deviceList.map((device, index) => {
                                    return(
                                        <option key={index} value={device.id}>{device.devicename}</option>
                                    )
                                })}
                            </select>
                        </div>
                        <div className="d-flex flex-column mt-3">
                            <p className="bold">{t("settings.message")}</p>
                            <textarea rows={5} onChange={(event) => setMessage(event.target.value)} className="form-control bg-light-grey" />    
                        </div>
                    </div>
                    <div className="d-flex flex-row p-3 justify-content-end border-settings-top align-items-center">
                        <Button onClick={() => props.onClose()}btnClass="btn-secondary me-2">{t("settings.cancel")}</Button>
                        <Button onClick={() => sendMessage()} btnClass={`btn-primary ${messageSent ? "disabled" : ""}`}>{messageSent ? t("settings.sent") : t("settings.send")}</Button>
                    </div>
                </div>
            </Card>
        </Dialog>
        </>
    )
}

export default NewSupportTicketModal;